import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
  name: () => [
    validations.required.text(),
    validations.min.text(3),
    validations.max.text(250),
  ],
  code: () => [
    validations.required.text(),
    validations.min.text(2),
    validations.max.text(20),
    validations.pattern.specialChar(),
  ],
};
